import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth.jsx";
import { I18nProvider } from "./lib/i18n.jsx";
import { Toaster } from "./components/ui/sonner";
import Sidebar from "./components/Sidebar.jsx";
import Footer from "./components/Footer.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { PageTitle } from "./lib/pageTitle.jsx";

import LandingPage from "./pages/LandingPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import RegisterPage from "./pages/RegisterPage.jsx";
import DiaryPage from "./pages/DiaryPage.jsx";
import RitualsPage from "./pages/RitualsPage.jsx";
import RitualDetailPage from "./pages/RitualDetailPage.jsx";
import LecturesPage from "./pages/LecturesPage.jsx";
import LectureDetailPage from "./pages/LectureDetailPage.jsx";
import LibraryPage from "./pages/LibraryPage.jsx";
import PrivacyPage from "./pages/PrivacyPage.jsx";
import TermsPage from "./pages/TermsPage.jsx";
import AdminPage from "./pages/AdminPage.jsx";
import AccountPage from "./pages/AccountPage.jsx";
import PantheonListPage from "./pages/PantheonListPage.jsx";
import PantheonDetailPage from "./pages/PantheonDetailPage.jsx";
import PantheonEditPage from "./pages/PantheonEditPage.jsx";
import TarotPersonalityPage from "./pages/TarotPersonalityPage.jsx";
import TarotCelticCrossPage from "./pages/TarotCelticCrossPage.jsx";
import TarotUltrasecretPage from "./pages/TarotUltrasecretPage.jsx";
import PodcastsPage from "./pages/PodcastsPage.jsx";

import "./App.css";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <PageTitle />
          <Sidebar />
          {/* On desktop we push all page content to the right of the 280px sidebar. */}
          <div className="lg:ml-[280px] min-h-screen flex flex-col">
            <div className="flex-1">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/diary" element={<ProtectedRoute><DiaryPage /></ProtectedRoute>} />
                <Route path="/rituals" element={<ProtectedRoute><RitualsPage /></ProtectedRoute>} />
                <Route path="/rituals/:slug" element={<ProtectedRoute><RitualDetailPage /></ProtectedRoute>} />
                <Route path="/lectures" element={<ProtectedRoute><LecturesPage /></ProtectedRoute>} />
                <Route path="/lectures/:id" element={<ProtectedRoute><LectureDetailPage /></ProtectedRoute>} />
                <Route path="/library" element={<ProtectedRoute><LibraryPage /></ProtectedRoute>} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/pantheon" element={<ProtectedRoute><PantheonListPage /></ProtectedRoute>} />
                <Route path="/pantheon/new" element={<ProtectedRoute><PantheonEditPage mode="create" /></ProtectedRoute>} />
                <Route path="/pantheon/:id" element={<ProtectedRoute><PantheonDetailPage /></ProtectedRoute>} />
                <Route path="/pantheon/:id/edit" element={<ProtectedRoute><PantheonEditPage mode="edit" /></ProtectedRoute>} />
                <Route path="/tarot/personality-card" element={<ProtectedRoute><TarotPersonalityPage /></ProtectedRoute>} />
                <Route path="/tarot/celtic-cross" element={<ProtectedRoute><TarotCelticCrossPage /></ProtectedRoute>} />
                <Route path="/tarot/ultrasecret" element={<ProtectedRoute><TarotUltrasecretPage /></ProtectedRoute>} />
                <Route path="/podcasts" element={<ProtectedRoute><PodcastsPage /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
                <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
              </Routes>
            </div>
            <Footer />
          </div>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
